import { createContext, useContext, useEffect, useMemo, useState, type ReactNode } from "react";
import { api } from "./api";

export const adminPermissions = ["catalog.manage", "inventory.manage", "orders.manage", "alerts.manage", "resellers.manage", "broadcasts.manage", "analytics.view", "subscribers.view", "customers.manage", "purchasing.manage", "finance.manage", "audit.view", "staff.manage"] as const;
export type AdminPermission = typeof adminPermissions[number];
export type AdminAccess = { id: string; email: string; role: "owner" | "manager" | "staff"; permissions: AdminPermission[] };

const AccessContext = createContext<{ access: AdminAccess | null; loading: boolean; can: (permission: AdminPermission) => boolean }>({ access: null, loading: true, can: () => false });

export function AccessProvider({ children }: { children: ReactNode }) {
  const [access, setAccess] = useState<AdminAccess | null>(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => { let active = true; void api<AdminAccess>("/admin/me").then((value) => active && setAccess(value)).catch(() => active && setAccess(null)).finally(() => active && setLoading(false)); return () => { active = false; }; }, []);
  const value = useMemo(() => ({ access, loading, can: (permission: AdminPermission) => Boolean(access?.permissions.includes(permission)) }), [access, loading]);
  return <AccessContext.Provider value={value}>{children}</AccessContext.Provider>;
}

export const useAccess = () => useContext(AccessContext);
